export default {"src":"/_next/static/media/icon-pin-red.8da99533.svg","height":55,"width":40,"blurWidth":0,"blurHeight":0};